import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { MatDialogConfig, MatDialog } from '@angular/material';
import { ProductService } from 'src/app/shared/services/product.service';
import { AddProductComponent } from '../add-product/add-product.component';
import { AddToppingGroupComponent } from '../add-topping-group/add-topping-group.component';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { AddCategorytComponent } from '../add-category/add-category.component';

@Component({
  selector: 'app-control-panel',
  templateUrl: './control-panel.component.html',
  styleUrls: ['./control-panel.component.scss']
})
export class ControlPanelComponent implements OnInit {
  cartProducts: any;
  constructor(public authService: AuthService, public dialog: MatDialog, private productService: ProductService, private spinnerService: SpinnerService) { }

  ngOnInit() {
  }
  addTopping() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { isTopping: true }
    const dialogRef = this.dialog.open(AddProductComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(topping => {
      this.productService.createTopping(topping);
    })
  }

  addCategory() {
    const dialogConfig = new MatDialogConfig();
    const dialogRef = this.dialog.open(AddCategorytComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(cat => {
      this.productService.createCategory(cat);
    })
  }

  addProduct() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { isTopping: false }
    const dialogRef = this.dialog.open(AddProductComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(product => {
      this.productService.createProduct(product);
    })
  }
  addToppingGroup() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { isTopping: false }
    const dialogRef = this.dialog.open(AddToppingGroupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(group => {
      this.productService.createToppingGroup(group);
    })
  }

}
